export const sleep = (time: number) => {
  return new Promise((resolve: (p: boolean) => void) => {
    setTimeout(() => {
      resolve(true);
    }, time);
  });
};

export const getPid = () => {
  const win: any = window;
  return win.projectID || '';
};
